import { useState } from 'react';
import * as backend from 'src/backend';

/**
 * Hook to check driver availability for a given time
 */
export default function useDriverAvailability() {
  const [isChecking, setIsChecking] = useState(false);
  const [error, setError] = useState(null);
  const [drivers, setDrivers] = useState([]);

  /**
   * Check availability for multiple drivers at once
   * @param {string} pickupTime - ISO string of pickup time
   * @param {string} endTime - ISO string of end time (optional)
   * @returns {Promise<Object>} - Map of driver IDs to availability
   */
  const checkAvailabilityForDrivers = async ({
    pickupTime,
    endTime,
    occurrenceType = null,
    interval = null,
    daysOfTheWeek = [],
    dayOfTheMonth,
  }) => {
    if (!pickupTime || !endTime) {
      return;
    }

    setIsChecking(true);
    setError(null);

    try {
      const _drivers = await backend.driver.getAvailableDriversForTeam({
        pickupTime,
        endTime,
        occurrenceType,
        interval,
        daysOfTheWeek,
        dayOfTheMonth,
      });
      setDrivers(_drivers);
    } catch (err) {
      setError(err.message || 'Failed to check driver availability');
      return {};
    } finally {
      setIsChecking(false);
    }
  };

  return {
    checkAvailabilityForDrivers,
    drivers,
    isChecking,
    error,
  };
}
